/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationmessagedeleted2Inputs */

const en_moderationmessagedeleted2 = /** @type {(inputs: Moderationmessagedeleted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message deleted`)
};

const de_moderationmessagedeleted2 = /** @type {(inputs: Moderationmessagedeleted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht gelöscht`)
};

/**
* | output |
* | --- |
* | "Message deleted" |
*
* @param {Moderationmessagedeleted2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationmessagedeleted2 = /** @type {((inputs?: Moderationmessagedeleted2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationmessagedeleted2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationmessagedeleted2(inputs)
	return de_moderationmessagedeleted2(inputs)
});
export { moderationmessagedeleted2 as "moderationMessageDeleted" }